import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";

export type BillingsOrderCargoTaxiDraftContractCargoCompany = {
  companyName: string;
  displayName: string;
};

export type BillingsOrderCargoTaxiDraftContract = {
  allowChargeWhileApproaching: boolean;
  allowChargeDuringRide: boolean;
  allowChargeWhileReturning: boolean;
  discountLimit: number;
  cargoCompany: BillingsOrderCargoTaxiDraftContractCargoCompany;
  model: BillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
};

export type BillingsOrderCargoTaxiDraftCargoOrder = {
  uuid: string;
  humanId: number;
};

export type BillingsOrderCargoTaxiDraftBillingNode = {
  uuid: string;
  nodeUuid: string;
  checkoutEventUuid?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinates: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export enum BillingsOrderCargoTaxiDraftBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAYS",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsOrderCargoTaxiDraftBillingContributionBaseAmount = {
  type: BillingsOrderCargoTaxiDraftBillingContributionType.BASE_AMOUNT;
  comment?: string;
  distance: number;
  rate: number;
};

export type BillingsOrderCargoTaxiDraftBillingContributionChargeHighways = {
  type: BillingsOrderCargoTaxiDraftBillingContributionType.CHARGE_HIGHWAYS;
  comment?: string;
  amount: number;
};

export type BillingsOrderCargoTaxiDraftBillingContributionChargeHaltings = {
  type: BillingsOrderCargoTaxiDraftBillingContributionType.CHARGE_HALTING;
  comment?: string;
  distance: number;
  amount: number;
};

export type BillingsOrderCargoTaxiDraftBillingContributionContractCorrectionPercentage =
  {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftBillingContributionDiscountOptimization =
  {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftBillingContributionDiscountBeingLate = {
  type: BillingsOrderCargoTaxiDraftBillingContributionType.DISCOUNT_BEING_LATE;
  comment?: string;
  amount: number;
};

export type BillingsOrderCargoTaxiDraftBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftBillingContributionDiscountOther = {
  type: BillingsOrderCargoTaxiDraftBillingContributionType.DISCOUNT_OTHER;
  comment?: string;
  amount: number;
};

export type BillingsOrderCargoTaxiDraftBillingContribution =
  | BillingsOrderCargoTaxiDraftBillingContributionBaseAmount
  | BillingsOrderCargoTaxiDraftBillingContributionChargeHighways
  | BillingsOrderCargoTaxiDraftBillingContributionChargeHaltings
  | BillingsOrderCargoTaxiDraftBillingContributionContractCorrectionPercentage
  | BillingsOrderCargoTaxiDraftBillingContributionDiscountOptimization
  | BillingsOrderCargoTaxiDraftBillingContributionDiscountBeingLate
  | BillingsOrderCargoTaxiDraftBillingContributionDiscountIncompatibleCar
  | BillingsOrderCargoTaxiDraftBillingContributionDiscountOther;

type BillingsOrderCargoTaxiDraft = {
  status: BillingStatus;
  passengers: string[];
  contract: BillingsOrderCargoTaxiDraftContract;
  baseAmountValue: number;
  amountForChargeHighways: number;
  amountForChargeHaltings: number;
  contractCorrectionPercentage: number;
  sumOfDiscounts: number;
  amountForDistance: number;
  allContributionsAmount: number;
  distance: number;
  date: Date;
  planEntryUuid: string;
  cargoOrder: BillingsOrderCargoTaxiDraftCargoOrder;
  billingNodes: BillingsOrderCargoTaxiDraftBillingNode[];
  billingContributions: BillingsOrderCargoTaxiDraftBillingContribution[];
};

export default BillingsOrderCargoTaxiDraft;
